<template>
    <VueSelect :options="options" class="v-select-light" multiple placeholder="Приоритет" v-model="value"></VueSelect>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import RequestPriorityType from '@/js/enums/RequestPriorityType';
import { priorityLabel } from '@/js/requestPriority';

@Component
class FilterPriority extends Vue {
    value = [];
    options = RequestPriorityType.values().map((priority) => ({
        value: priority,
        label: priorityLabel(priority),
    }));

    getValue() {
        return this.value.map((value) => value.value);
    }

    setValue(newValue) {
        this.value = this.options.filter((option) => newValue.includes(option.value));
    }

    reset() {
        this.value = [];
    }
}

export default FilterPriority;
</script>
